import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { ReactiveFormsModule, FormControl, Validators, FormsModule } from '@angular/forms';
import { MaterialModule } from '../../material/material.module';
import { PipesModule } from '../../pipes/pipes.module';
import { AssignedCategory } from '../../models/assignedCategory';
import { FORM_LINK_REGEX } from '../../utils/utils';
import { isNullOrUndefined } from '@pineapplelab/util';

@Component({
  selector: 'app-form-link-dialog',
  standalone: true,
  imports: [
    MatDialogModule,
    CommonModule,
    MaterialModule,
    PipesModule,
    ReactiveFormsModule,
    FormsModule
  ],
  templateUrl: './form-link-dialog.component.html',
  styleUrl: './form-link-dialog.component.scss'
})
export class FormLinkDialogComponent implements OnInit {

  assignedCategory: AssignedCategory;
  formLinkControl: FormControl;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<FormLinkDialogComponent>
  ) {
    this.assignedCategory = data.assignedCategory;

    this.formLinkControl = new FormControl('', [
      Validators.pattern(new RegExp(FORM_LINK_REGEX))
    ]);
  }

  ngOnInit(): void {
    const linkWithoutProtocol = this.stripProtocol(this.assignedCategory.formLink || '');
    this.formLinkControl.setValue(linkWithoutProtocol);
    if (isNullOrUndefined(this.assignedCategory.requireFormFirst)) {
      this.assignedCategory.requireFormFirst = false;
    }
  }

  private stripProtocol(link: string): string {
    return link.replace(/^https?:\/\//, '');
  }

  private formatWithHttps(link: string): string {
    return link ? `https://${this.stripProtocol(link)}` : '';
  }

  save(): void {
    this.formLinkControl.markAsTouched();

    if (this.formLinkControl.invalid) return;

    const formatted = this.formatWithHttps(this.formLinkControl.value);
    this.assignedCategory.formLink = formatted;

    this.dialogRef.close({ assignedCategory: this.assignedCategory });
  }

  close(): void {
    this.dialogRef.close();
  }
}
